import { colors } from '@karnott/colors';
import { color } from '../ui/theme';
import { Values } from '../utils/types';

export const DEVICE_CONSTANTS = {
  TYPE: {
    KARNOTT: 'Karnott',
    BEACON: 'Karnott Outil',
    DRIVER_BEACON: 'Karnott Chauffeur',
  },
  BEACON_TYPE: {
    EQUIPMENT: 'EQUIPMENT',
    DRIVER: 'DRIVER',
  },
  STATUS: {
    DELETED: 'DELETED',
    IN_USE: 'IN_USE',
    AVAILABLE: 'AVAILABLE',
  },
  HEALTH_STATUS: {
    UP: 'UP',
    DOWN: 'DOWN',
    CRITICAL: 'CRITICAL',
  },
  BATTERY: {
    COLOR: {
      CRITICAL_LEVEL_COLOR: colors('orange', 'dark'),
      LOW_LEVEL_COLOR: color('yellow'),
      HIGH_LEVEL_COLOR: colors('green'),
    },
    LEVEL: {
      LOW_STEP: 30,
      CRITICAL_STEP: 15,
    },
    HEALTH_STATUS: {
      OK: 'OK',
      WARNING: 'WARNING',
      CRITICAL: 'CRITICAL',
    },
  },
  CHARGING_STATE: {
    DISCHARGING: 'DISCHARGING',
    CHARGING: 'CHARGING',
    CHARGED: 'CHARGED',
  },
  WARRANTY_STATUS: {
    UNDER_WARRANTY: 'UNDER_WARRANTY',
    NO_WARRANTY: 'NO_WARRANTY',
    UNKNOWN: 'UNKNOWN',
  },
  STATE_WITH_CLUSTER: {
    LENDING: 'lending',
    RENT: 'location',
  },
} as const;

export type BeaconType = Values<typeof DEVICE_CONSTANTS.BEACON_TYPE>;
export type DeviceType = Values<typeof DEVICE_CONSTANTS.TYPE>;
export type DeviceStatus = Values<typeof DEVICE_CONSTANTS.STATUS>;
export type DeviceStateWithCluster = Values<typeof DEVICE_CONSTANTS.STATE_WITH_CLUSTER>;
export type DeviceHealthStatus = Values<typeof DEVICE_CONSTANTS.HEALTH_STATUS>;
export type DeviceChargingState = Values<typeof DEVICE_CONSTANTS.CHARGING_STATE>;
export type BatteryHealthStatus = Values<typeof DEVICE_CONSTANTS.BATTERY.HEALTH_STATUS>;
